import { get, put } from './requests'

export const getDestinations = (payload) => get(['destinations'], {}, payload)

export const getDestination = (payload) => get(['destinations', payload], {})

export const updateDestination = (id, payload) => put(['destinations', id], {}, payload)

export const getMappingIds = () => get(['mapping-ids?fields=_id&fields=name&limit=1000'])

export const getSalesforceIntegrationPartners = () =>
  get(['salesforce-integration-partners?fields=_id&fields=name&limit=1000'])

export const getDestinationChangeRequest = (id) => get(['destination-change-requests', id])

export const updateDestinationChangeRequest = (id, payload) =>
  put(['destination-change-requests', id], {}, payload)

export const getEnumCreatedBy = () =>
  get(['destination-change-requests', 'enum', 'created_by.email'], {})
